export const INDICATOR_SIZE = {
    LARGE: 'large',
    SMALL: 'small',
    TINY: 'tiny',
};
export const INDICATOR_COLOR = {
    HIGHLIGHT: 'highlight',
    NEUTRAL: 'neutral',
    DANGER: 'danger',
    ALERT: 'alert',
    POSITIVE: 'positive',
    INFORMATIVE: 'informative',
};
export const INDICATOR_MAX_COUNT = 999;
export const INDICATOR_OVERFLOW_LABEL = '99+';
